import { OlTeflPrice } from '../../../lib/types/models/ol/tefl-price/ol-tefl-price'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

type DuplicateOlTeflPriceInput = {
  olId: number
  id: number
}

export const duplicateOlTeflPrice = async (data: DuplicateOlTeflPriceInput) => {
  const { id, olId } = data
  return restApiClient
    .url(constructApiUrl(API.ols.duplicateOlTeflPrice.url, { olId, id }))
    .post<OlTeflPrice>()
}
